import React from 'react';
import styled, { css } from 'styled-components';
import { spacing } from 'ui/theme/utils';

const disabledOpacity = 0.5;

export const ButtonWrapper = styled.button.attrs(({ type, text, children }) => ({
  type: type || 'button',
  children: text || children,
}))`
  ${({ variant = 'primary' }) => {
    switch (variant) {
      case 'danger':
        return css`
          ${({ look }) => look !== 'underline' && 'background-color: #fae8e8;'}
          color: #f74c4c;
        `;
      case 'warning':
        return css`
          background-color: #ffecd2;
          color: #ac7206;
        `;
      case 'danger-dark':
        return css`
          background-color: #f74c4c;
          color: #fff;
        `;
      case 'contrast-primary':
        return css`
          background-color: #e5efff;
          color: ${({ theme }) => theme.colors.primary};
        `;
      case 'contrast-success':
        return css`
          background-color: #dffbe4;
          color: #00aa22;
        `;
      case 'outline':
        return css`
          background-color: transparent;
          border: 1px solid #e5efff;
          color: #fff;
          box-shadow: none;
        `;
      case 'text':
        return css`
          background-color: transparent;
          box-shadow: none !important;
          color: ${({ theme }) => theme.colors.primary};
        `;
      default:
        return css`
          background-color: ${({ theme }) => theme.colors[variant]};
          color: ${({ theme }) => theme.colors.white};
        `;
    }
  }}
  ${({ look = 'default' }) => {
    switch (look) {
      case 'flat':
        return `
          border-radius: 0;
        `;
      case 'underline':
        return `
          background-color: transparent;
          text-decoration: underline;
        `;
      default:
        return css`
          box-shadow: ${({ boxShadow = 'bottom', theme }) => theme.shadows[boxShadow] || boxShadow};
          border-radius: ${({ borderRadius = '8px' }) => borderRadius};
        `;
    }
  }}
  position: relative;
  border: none;
  width: ${({ width = '100%' }) => width};
  ${({ minWidth }) => minWidth && `min-width: ${minWidth};`};
  padding: ${({ padding = '9px' }) => padding};
  font-size: ${({ fontSize = '15px' }) => fontSize};
  font-weight: ${({ fontWeight = 500 }) => fontWeight};
  letter-spacing: 0.7px;
  text-align: center;
  transition: opacity 300ms ease-in-out;
  &:hover {
    opacity: ${({ disabled }) => (disabled ? disabledOpacity : '0.9')};
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: ${disabledOpacity};
      cursor: ${({ disabledCursor = 'not-allowed' }) => disabledCursor};
    `}
  ${({ size = 'default' }) => {
    switch (size) {
      case 'small':
        return css`
          font-size: 12px;
          padding: 6px;
          width: auto;
        `;
    }
  }}
  ${(props) => spacing(props)}
  ${({ alignSelf }) =>
    alignSelf &&
    `
    align-self: ${alignSelf};
  `}
`;

const IconWithButtonWrapper = styled.div`
  position: relative;
  ${(props) => spacing(props)}
`;

const IconWrapper = styled.div`
  position: absolute;
  right: 5%;
  bottom: 25%;
`;

export const Button = ({ hasDropDown = false, dropDown = null, children, ...rest }) => {
  if (!hasDropDown || !dropDown) {
    return <ButtonWrapper {...rest}>{children}</ButtonWrapper>;
  }

  const { mt, ml, mr, mb, mx, my, ...buttonProps } = rest;
  const marginProps = { mt, ml, mr, mb, mx, my };

  return (
    <IconWithButtonWrapper {...marginProps}>
      <ButtonWrapper {...buttonProps}>{children}</ButtonWrapper>
      {hasDropDown && dropDown && <IconWrapper>{dropDown}</IconWrapper>}
    </IconWithButtonWrapper>
  );
};
